import { XMarkIcon } from '@heroicons/react/24/solid'
import React from 'react'

const ActiveFilter = ({activeFilters , removeFilter , handleResetFilters}) => {
  return (
    activeFilters?.length > 0 && (
       <div className="bg-white py-2">
                    <div className="mx-auto flex flex-wrap items-center">
                      <h3 className="mr-2 text-md font-medium text-gray-900">
                        Active Filters:
                      </h3>
                      <div className="mt-1 flex flex-wrap items-center gap-y-2 gap-x-2">
                        {activeFilters.map((filter, filterIdx) => (
                          <button
                            key={filterIdx}
                            onClick={() => removeFilter(filter.type, filter.value)}
                            className="inline-flex items-center rounded-full border border-gray-200 bg-gray-100 hover:bg-gray-300 py-1.5 pl-3 pr-2 text-sm font-medium text-gray-700 cursor-pointer"
                          >
                            <span>{filter.value}</span>
                            <XMarkIcon
                              className="ml-1 h-4 w-4 text-gray-500"
                              aria-hidden="true"
                            />
                          </button>
                        ))}
                        {activeFilters.length > 0 && (
                          <div
                            onClick={handleResetFilters}
                            className="inline-flex items-center rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-2 text-sm font-medium text-red-300 hover:text-red-500 cursor-pointer"
                          >
                            Clear all
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
    )
  )
}

export default ActiveFilter
